import React, {Component} from "react";
import styles from "./AccountTable.module.css";
import classNames from "classnames";
import {withApplicationContext} from "../../../contexts/ApplicationContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { numberWithCommas } from "../../../helpers/helpers";
import TableColValue from "./TableColValue";
class TableColAmountValue extends Component {
    constructor(props) {
        super(props);

    }
    render() {
        const { yellow, value, red, green, className, onClick } = this.props
        return (
            <TableColValue>
                <div className={styles.AmountCol}>
                    <div class={classNames(styles.AmountColSign, yellow && "yellow-text", red && "red-text", green && "green-text")}>USD</div>
                    <div onClick={onClick??null} class={classNames(styles.AmountColPrice, yellow && "yellow-text", red && "red-text", green && "green-text", className, onClick && "underline-link")}>
                        {value && numberWithCommas(value)}
                    </div>
                </div>
            </TableColValue>

        );
    }
}
export default withApplicationContext(TableColAmountValue);